import { FC, useEffect } from "react";
import {
    Text,
    Heading,
    Container,
    Flex,
} from "@smile2impress/components/relaunch";

import { SentryErrorType } from "constants/enum";
import { ErrorPropsItem } from "content/error/types";
import { reportToSentry } from "utils/reportToSentry";
import { AnalyticsIdElement } from "constants/analytics";

export const ErrorNotFound: FC<ErrorPropsItem> = ({
    errorCode,
    title,
    subtitle,
}) => {
    useEffect(() => {
        reportToSentry({
            error: SentryErrorType.PAGE_NOT_FOUND,
            level: "error",
        });
    }, []);

    return (
        <Flex
            id={AnalyticsIdElement.NOT_FOUND}
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            p="100px 24px"
        >
            <Container size="m">
                <Text
                    mb="2"
                    textStyle="body"
                    color="text.tertiary"
                    fontSize={["96", "144", "240"]}
                >
                    {errorCode}
                </Text>
                <Heading mb={["1", "2"]} textStyle="title1">
                    {title}
                </Heading>
                <Text textStyle="body">{subtitle}</Text>
            </Container>
        </Flex>
    );
};
